import { useContext } from 'react';
import { FormControl, InputLabel, MenuItem, Select, OutlinedInput, Container, Typography} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { styles } from '../styles/filterStyles';
import FilterIcon from '../assets/filterIcon.svg';

import GlobalAppContext from '../../context';
import { useTheme } from '@mui/material/styles';

const DashboardFilter = ({filterValues, setFilterValues, districts, schools}) => {
  const theme = useTheme();
  const { namespace  } = useContext(GlobalAppContext);
  const style = styles(theme);
  const user = JSON.parse(localStorage.getItem('user'));

  const handleDistrictsChange = (event) => {
    filterValues.district = event.target.value
    setFilterValues({...filterValues})
  };
  const handleSchoolsChange = (event) => {
    filterValues.school = event.target.value
    setFilterValues({...filterValues})
  };

  const handleDateChange = (type, value) => {
    filterValues[type] = value
    setFilterValues({...filterValues})
  };

  return (
    <Container sx={style.filterContainer}>
      <Container sx={style.leftContainer}>
        <img src={FilterIcon} alt='filter-icon' />
        <Typography sx={style.title}>{namespace.dashboard.filter}:</Typography>
        {user.permission === "disclosureAdmin" &&
          <FormControl sx={style.districtSelect}>
            <InputLabel id="all-districts-label">District</InputLabel>
            <Select
              labelId="all-districts-label"
              id="all-districts"
              value={filterValues.district}
              label={"District"}
              onChange={handleDistrictsChange}
            >
              {districts.map((district) => (
                <MenuItem key={district.label} value={district.value}>
                  {district.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        }
        {(user.permission === "disclosureAdmin" || user.permission === "districtAdmin") &&
          <FormControl sx={style.SchoolSelect}>
            <InputLabel id="all-schools-label">School</InputLabel>
            <Select
              labelId="all-schools-label"
              id="all-schools"
              value={filterValues.school}
              input={<OutlinedInput label={"School"} />}
              onChange={handleSchoolsChange}
            >
              {schools.map((school) => (
                <MenuItem key={school.label} value={school.value}>
                  {school.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        }
      </Container>
      <Container sx={style.rightContainer}>
        <Container sx={style.startDate}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Start Date"
              value={filterValues.startDate}
              onChange={(newValue) => handleDateChange("startDate", newValue)}
            />
          </LocalizationProvider>
        </Container>
        <Container sx={style.endDate}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="End Date"
              value={filterValues.endDate}
              onChange={(newValue) => handleDateChange("endDate", newValue)}
            />
          </LocalizationProvider>
        </Container>
      </Container>
    </Container>
  )
}

export default DashboardFilter;